import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import ErrorBoundary from "./components/errorBoundry.tsx";
import LoadingScreen from "./components/loadingScreen.tsx"; // Import the LoadingScreen component
import { i18nInstance } from "./i18n.ts";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
i18nInstance.init(() => {
  root.render(
    <React.StrictMode>
      <ChakraProvider>
        <LoadingScreen /> {/* Add the LoadingScreen here */}
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </ChakraProvider>
    </React.StrictMode>
  );
});
